/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Status_AllInputs */

const cs_gdpr_status_all = /** @type {(inputs: Gdpr_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vše`)
};

const en_gdpr_status_all = /** @type {(inputs: Gdpr_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Gdpr_Status_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_status_all = /** @type {((inputs?: Gdpr_Status_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Status_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_status_all(inputs)
	return cs_gdpr_status_all(inputs)
});